export default "__VITE_ASSET__DYDGyFb9__"